const MenuData = [
    { name: '基础设置', id: 0},
    { name: '地图设置', id: 1},
    { name: '分类设置', id: 2},
    { name: '点位设置', id: 3},
    { name: '弹窗设置', id: 4},
    { name: '高级设置', id: 5}
]

const cdata = {
    MenuData: MenuData
}

export default cdata